// src/api.js
import axios from 'axios';

// Dynamically target the correct port on localhost, otherwise use relative path in production
const API_URL = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
    ? 'http://localhost:4001/api'
    : '/api';

const api = axios.create({
    baseURL: API_URL,
    withCredentials: true // Crucial for passing cookies/SSO tokens securely
});

// Request Interceptor: Attach token to outgoing requests
api.interceptors.request.use(
  (config) => {
    // 1. Get the token from localStorage
    const token = localStorage.getItem('token');

    // 2. If the token exists, add it to the request's Authorization header
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // 3. Return the modified request config
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor: Capture refreshed tokens and handle session expiration
api.interceptors.response.use(
  (response) => {
    // 1. Check if the backend sent a refreshed token in the headers
    const refreshToken = response.headers['x-refresh-token'];
    if (refreshToken) {
      // 2. Update the token in localStorage so subsequent requests use the new one
      localStorage.setItem('token', refreshToken);
    }
    return response;
  },
  (error) => {
    // 3. If the token is expired or invalid (401 Unauthorized)
    // Only trigger redirects in production; ignore local development bypass states
    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    
    if (error.response && error.response.status === 401 && !isLocal) {
      localStorage.removeItem('token');
      
      // Redirect to login page (only if not already on the login page)
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
